import { EContainerTypes, IMainFormQuestion } from '../types';

export const useMainFormQuestion = (containerType: EContainerTypes): IMainFormQuestion => {
  const totalQuestionsCount = 4;
  switch (containerType) {
    case EContainerTypes.IsMorgageQuestion:
    default:
      return {
        answerYes: 'Не в залоге',
        answerNo: 'В залоге',
        containerType: EContainerTypes.IsMorgageQuestion,
        question: 'Ваш объект находится в залоге?',
        stepYes: EContainerTypes.OwnerCitizenshipQuestion,
        stepNo: EContainerTypes.EncumbranceWillBeRemoved,
        totalQuestionsCount,
        questionNumber: 1,
      };
    case EContainerTypes.EncumbranceWillBeRemoved:
      return {
        answerYes: 'Да',
        answerNo: 'Нет',
        containerType: EContainerTypes.EncumbranceWillBeRemoved,
        question: 'Обременение будет снято при продаже вашего объекта? ',
        stepYes: EContainerTypes.OwnerCitizenshipQuestion,
        stepNo: EContainerTypes.FormFailed,
        totalQuestionsCount,
        questionNumber: 2,
      };
    case EContainerTypes.OwnerCitizenshipQuestion:
      return {
        answerYes: 'Да',
        answerNo: 'Нет',
        containerType: EContainerTypes.OwnerCitizenshipQuestion,
        question: 'Все собственники граждане РФ?',
        stepYes: EContainerTypes.MaternityCapitalQuestion,
        stepNo: EContainerTypes.FormFailed,
        totalQuestionsCount,
        questionNumber: 3,
      };
    case EContainerTypes.MaternityCapitalQuestion:
      return {
        answerYes: 'Не использовался',
        answerNo: 'Использовался',
        containerType: EContainerTypes.MaternityCapitalQuestion,
        question: 'Материнский капитал использовался при покупке?',
        stepYes: EContainerTypes.LabelAdded,
        stepNo: EContainerTypes.FormFailed,
        totalQuestionsCount,
        questionNumber: 4,
      };
  }
};
